import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LazyLoadImageModule } from 'ng-lazyload-image';

import { DataService } from '@/services/data.service';
import { WalletAddressDirective } from '@/directives/wallet-address.directive';
import { TokenIdParsePipe } from '@/pipes/token-id-parse.pipe';
import { environment } from 'src/environments/environment';

export interface StashBid {
  id: string;
  bidder_address?: string;
  bid_amount_eth: number;
  expires_at?: string;
  [key: string]: any;
}

@Component({
  selector: 'app-select-punk-modal',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    LazyLoadImageModule,
    WalletAddressDirective,
    TokenIdParsePipe
  ],
  templateUrl: './select-punk-modal.component.html',
  styleUrls: ['./select-punk-modal.component.scss']
})
export class SelectPunkModalComponent {
  @Input() isActive: boolean = false;
  @Input() bid: StashBid | null = null;
  @Input() matchingPunkIds: number[] = [];
  @Output() closed = new EventEmitter<void>();
  @Output() punkSelected = new EventEmitter<number>();

  protected readonly environment = environment;

  constructor(public dataSvc: DataService) {}

  selectPunk(punkId: number): void {
    this.punkSelected.emit(punkId);
  }

  closeModal(): void {
    this.closed.emit();
  }
}
